import { Directive, Input } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  Validator,
  ValidatorFn,
  Validators
} from '@angular/forms';

export function validateState(states): ValidatorFn {
  const statesIds = Object.keys(states).map(function(key) {
    return states[key]['id'];
  });
  const statesNames = Object.keys(states).map(function(key) {
    return states[key]['name'];
  });

  // let result = 0;
  // states.foreach(obj => console.log(obj));
  return (control: AbstractControl): { [key: string]: any } => {
    if (!control.value) {
      return null;
    }

    if (statesNames.indexOf(control.value) > 0) {
      return null;
    }

    return { validateState: { value: control.value } };
  };
}

@Directive({
  selector: '[validateState]',
  providers: [
    {
      provide: [NG_VALIDATORS],
      useExisting: ValidateStateDirective,
      multi: true
    }
  ]
})
export class ValidateStateDirective implements Validator {
  @Input()
  states: string;

  validate(control: AbstractControl): { [key: string]: any } {
    return validateState(this.states)(control);
  }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/common/validators/state-validators.directive.ts